import ArtistFormContainer from './ArtistFormContainer'
import ArtistApplyFormStep from './ArtistFormStep'
import ArtistApplySuccess from './ArtistFormSuccess'

export type {
  ArtistFormField,
  ArtistFormProps,
  ArtistFormQuestions,
  FormInputs,
} from './ArtistFormStep.types'

export { ArtistApplyFormStep, ArtistApplySuccess }

export default ArtistFormContainer
